
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/videos",
      function () {
        return require("private-next-pages/components/videos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/videos"])
      });
    }
  